import { StyleSheet } from "react-native";
const style = StyleSheet.create({
    container: {
        flexDirection: "column",
        justifyContent: "flex-start",
    },
});
export { style };
